import { Image, Link } from '@akinon/next/components';
import { MenuItemType } from '@akinon/next/types';
import clsx from 'clsx';

export const MenuList = ({
  item,
  className,
  LinkComponent = Link
}: {
  item: MenuItemType;
  className?: string;
  LinkComponent?: React.ComponentType<{
    href: string;
    className?: string;
    children: React.ReactNode;
  }>;
}) => {
  return (
    <>
      {item.children?.length > 0 && (
        <ul
          className={clsx([className, 'md:max-h-[--max-height]'])}
          data-level={item.level}
          style={
            item.extra_context?.attributes?.max_height?.value &&
            ({
              flexWrap: 'wrap',
              '--max-height': item.extra_context?.attributes?.max_height?.value
            } as unknown)
          }
        >
          {item.children.map((children, index) => (
            <li
              key={index}
              data-level={item.level}
              className={clsx([
                item.level === 1 && 'pt-6 md:pt-5',
                item.level === 1 && '[&>ul]:md:pt-5',
                item.level === 3 && 'pl-3',
                item.level === 2 &&
                  children.children.length > 0 &&
                  '[&>ul]:md:pb-3 pt-4 lg:pt-0',
                children.children.length === 0 && 'pt-4 md:pt-1',
                item.level === 1 &&
                  item.extra_context?.attributes?.children_direction?.value !==
                    'row' &&
                  'pb-7 pr-10',
                item.level === 1 &&
                  item.extra_context?.attributes?.children_direction?.value ===
                    'row' &&
                  'pr-18'
              ])}
            >
              {children.url === '' || children.url === '#' ? (
                <span className="text-gray">{children.label}</span>
              ) : (
                <LinkComponent
                  href={children.url}
                  className={clsx([
                    item.level === 1 && 'text-lg font-medium md:text-xl'
                  ])}
                >
                  {children?.extra_context?.attributes?.link_image?.kwargs
                    ?.url ? (
                    <Image
                      src={
                        children?.extra_context?.attributes?.link_image?.kwargs
                          ?.url
                      }
                      alt={children.label}
                      className="h-[24px] w-auto"
                      imageClassName="h-full w-full object-contain"
                      width={150}
                      height={150}
                    />
                  ) : (
                    children.label
                  )}
                </LinkComponent>
              )}
              <MenuList
                item={children}
                className={clsx([
                  'md:flex',
                  children.extra_context?.attributes?.children_direction
                    ?.value !== 'row' && 'flex-col',
                  children.extra_context?.attributes?.children_direction
                    ?.value === 'row' && 'flex-row'
                ])}
                LinkComponent={LinkComponent}
              />
            </li>
          ))}
        </ul>
      )}
    </>
  );
};
